function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef, useCallback, useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import styled, { css } from 'styled-components';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { Box } from '@cbhq/cds-web/layout';
import { DEFAULT_LOGGED_OUT_CONFIG } from '@cbhq/intl';
import useMainCTACopy from '../../../utils/useMainCTACopy/useMainCTACopy.js';
import useScrollBreakpoint from '../../../utils/useScrollBreakpoint.js';
import '../../Link/index.js';
import '../../MenuToggle/index.js';
import { AppWidePersistentBanner } from '../AppWidePersistentBanner.js';
import Banner, { BANNER_HEIGHT } from '../Banner.js';
import '../constants/index.js';
import GlobalNavContext from '../context/GlobalNavContext.js';
import '../CountryBanner/index.js';
import LogoWrapper from '../LogoWrapper.js';
import '../MainNav/index.js';
import messages from '../messages.js';
import SubNav, { SUBNAV_HEIGHT } from '../SubNav.js';
import { MOBILE_NAV_HEIGHT } from './constants.js';
import MobileMenu from './MobileMenu.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { FLOATING_HEADER_PX_BREAKPOINT } from '../constants/constants.js';
import { ButtonWrapper } from '../MainNav/MainNav.js';
import Link from '../../Link/Link.js';
import MenuToggle from '../../MenuToggle/MenuToggle.js';
import CountryBanner from '../CountryBanner/CountryBanner.js';
const DISCLAIMER_BANNER_HEIGHT = 98;
function MobileNav({
  navLinks,
  activeTab,
  setSelectedTab,
  subNavLinks,
  mainCTA,
  secondaryCTA,
  banner,
  isInRewardsHubExperiment,
  customLogoUrl,
  localeInformation,
  userLocaleInfo,
  isCountryBannerDismissed,
  disableStickyness
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const mobileNavBannerRef = useRef(null);
  const mobileNavBannerHeight = mobileNavBannerRef.current?.children[0].clientHeight || 0;
  const toggleIsOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalNavContext),
    signUpUrl = _useContext.signUpUrl,
    onClickSignUp = _useContext.onClickSignUp,
    showSignUpButton = _useContext.showSignUpButton,
    isUKUser = _useContext.isUKUser,
    isCountrySwitchBannerEnabled = _useContext.isCountrySwitchBannerEnabled,
    detachBannerFromNav = _useContext.detachBannerFromNav;
  const mainCTACopy = useMainCTACopy(mainCTA);
  const detached = useScrollBreakpoint({
    top: FLOATING_HEADER_PX_BREAKPOINT
  });
  const handleKeyPress = useCallback(event => {
    if (event.key === 'Enter') {
      toggleIsOpen();
    }
    if (event.key === 'Escape' && isOpen) {
      toggleIsOpen();
    }
  }, [isOpen, toggleIsOpen]);
  const ariaControls = {
    'aria-expanded': isOpen ? true : false,
    'aria-controls': 'global-nav-mobile-dropdown',
    'aria-label': isOpen ? formatMessage(messages.ariaMobileMenuClose) : formatMessage(messages.ariaMobileMenuOpen),
    role: 'button'
  };
  const isSupportedCountryFromIp = (userLocaleInfo?.countryFromIp?.toLowerCase() || '') in DEFAULT_LOGGED_OUT_CONFIG;
  const showCountryBanner = isCountrySwitchBannerEnabled && isSupportedCountryFromIp && userLocaleInfo && !isCountryBannerDismissed && userLocaleInfo.countryFromIp !== userLocaleInfo.countryFromUrl;
  const handleOnClick = useCallback(() => toggleIsOpen(), [toggleIsOpen]);
  const handleOnKeyDown = useCallback(e => handleKeyPress(e), [handleKeyPress]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(HeightPlaceholder, {
      $hasSubNav: !!(subNavLinks && !isOpen),
      $hasBanner: !!(banner && !isUKUser),
      $hasUKDisclaimer: !!isUKUser
    }), /*#__PURE__*/jsxs(Wrapper, {
      $isOpen: isOpen,
      $disableStickyness: disableStickyness,
      children: [banner && !isUKUser && /*#__PURE__*/jsx(Box, {
        ref: mobileNavBannerRef,
        children: /*#__PURE__*/jsx(Banner, {
          message: banner.message,
          url: banner.url,
          onClick: banner.onClick,
          superMessage: banner.superMessage,
          theme: banner.theme,
          textInBlue: banner.textInBlue
        })
      }, "mobileNavBanner"), /*#__PURE__*/jsx(Box, {
        flexDirection: "column",
        width: "100%",
        style: {
          marginTop: detachBannerFromNav ? mobileNavBannerHeight : 0
        },
        children: /*#__PURE__*/jsxs(MobileNavWrapper, {
          $hasBanner: !!(banner && !isUKUser),
          children: [/*#__PURE__*/jsx(LogoWrapper, {
            customLogoUrl: customLogoUrl
          }), showSignUpButton && /*#__PURE__*/jsx(ButtonWrapper, {
            children: /*#__PURE__*/jsx(Link, {
              logEvents: true,
              to: signUpUrl,
              title: formatMessage(mainCTACopy || messages.signUpLink),
              testID: "header-get-started-button",
              onClick: onClickSignUp,
              children: /*#__PURE__*/jsx(Button, {
                compact: true,
                analyticsId: "abcb815d-7132-420b-ae00-d7bf117ca55c",
                children: formatMessage(mainCTACopy || messages.signUpLink)
              })
            })
          }), /*#__PURE__*/jsx(MenuToggleWrapper, _objectSpread(_objectSpread({
            onClick: handleOnClick,
            "data-testid": "mobile-menu-toggle",
            tabIndex: 0,
            onKeyDown: handleOnKeyDown
          }, ariaControls), {}, {
            children: /*#__PURE__*/jsx(MenuToggle, {
              isOpen: isOpen
            })
          }))]
        })
      }), isUKUser && /*#__PURE__*/jsx(AppWidePersistentBanner, {}), (!detached || disableStickyness) && showCountryBanner && /*#__PURE__*/jsx(CountryBanner, {
        countryFromIp: userLocaleInfo?.countryFromIp,
        countryFromUrl: userLocaleInfo?.countryFromUrl
      }), subNavLinks && !isOpen && /*#__PURE__*/jsx(SubNav, {
        links: subNavLinks
      }), isOpen && /*#__PURE__*/jsx(MobileMenu, {
        isOpen: isOpen,
        activeTab: activeTab,
        setSelectedTab: setSelectedTab,
        navLinks: navLinks,
        mainCTA: mainCTA,
        secondaryCTA: secondaryCTA,
        isInRewardsHubExperiment: isInRewardsHubExperiment,
        localeInformation: localeInformation,
        userLocaleInfo: userLocaleInfo,
        banner: banner
      })]
    })]
  });
}
const MobileNav$1 = /*#__PURE__*/memo(MobileNav);
const HeightPlaceholder = styled.div`
  height: ${({
  $hasSubNav,
  $hasBanner,
  $hasUKDisclaimer
}) => MOBILE_NAV_HEIGHT + ($hasSubNav ? SUBNAV_HEIGHT : 0) + ($hasBanner ? BANNER_HEIGHT : 0) + ($hasUKDisclaimer ? DISCLAIMER_BANNER_HEIGHT : 0)}px;
  position: relative;
`;
const Wrapper = styled.header`
  position: ${({
  $disableStickyness
}) => $disableStickyness ? 'static' : 'fixed'};
  width: 100%;
  ${({
  $isOpen
}) => $isOpen ? css`
          height: 100%;
        ` : ''}
  top: 0;
  display: flex;
  flex-direction: column;
  background: ${({
  theme
}) => theme.color.background};
  z-index: ${({
  theme
}) => theme.zIndex.high};
  /* hack to fix issue with retina screens having 1px top space when using sticky */
  box-shadow: 0 -1px 0px 1px ${({
  theme
}) => theme.color.background};
`;
const MobileNavWrapper = styled.div`
  max-width: ${p => p.theme.layout.width}px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  padding: 0 20px;
  border-bottom: 1px solid ${p => p.theme.color.border};
  height: ${MOBILE_NAV_HEIGHT}px;
  background-color: ${p => p.theme.color.background};
`;
const MenuToggleWrapper = styled.div`
  padding: 10px;
  margin: 10px -10px 10px 20px;
`;
export { MobileNav$1 as default };
//# sourceMappingURL=MobileNav.js.map
